// extracted by mini-css-extract-plugin
export var searchHeader = "_8q-0";
export var searchHeaderDark = "_8q-1";